export default __webpack_public_path__ + "images/mock/car_test_result-mobile.png";